<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="13" :sm="24" :md="14" :xs="24">
        <el-card>
          <el-container direction="vertical">
            <el-main>
              <el-row :gutter="20">
                <el-col>
                  <el-form
                    ref="form"
                    :model="model"
                    :rules="rules"
                    label-position="left"
                    size="small"
                    label-width="140px"
                    :show-message="true"
                    :inline-message="true"
                  >
                    <el-row type="flex column">
                      <el-col>
                        <el-form-item label="Negociacion" prop="Name">
                          <el-input v-model="model.Name"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <div style="width: 300px; height: 10px">
                      <el-progress :percentage="0"></el-progress>
                    </div>

                    <el-row :gutter="20" class="mt-20" type="flex column">
                      <el-col :span="8" :xs="24" :sm="24" :md="24" :lg="12">
                        <el-form-item label="Cliente" prop="ContactName">
                          <el-select
                            v-model="model.ContactName"
                            v-loading="loading_customers"
                            clearable
                            filterable
                            reserve-keyword
                            placeholder="Seleccionar o buscar cliente"
                            :disabled="disableCustomerName"
                            @change="handleChangeContactName"
                          >
                            <el-option
                              v-for="(item, index) in list_customers"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="Contrato" prop="ContractTimeID">
                          <el-select
                            v-model="model.ContractTimeID"
                            v-loading="loading"
                            clearable
                            placeholder="Seleccionar contrato"
                            filterable
                          >
                            <el-option
                              v-for="item in list_times"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              :disabled="!item.IsEnabled"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="Servicio" prop="DealsTypeID">
                          <el-select
                            v-model="model.DealsTypeID"
                            v-loading="loading"
                            clearable
                            placeholder="Tipo de servicio"
                          >
                            <el-option
                              v-for="item in list_deal_of_types"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              :disabled="!item.IsEnabled"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <!-- <el-form-item label="Codigo">
                          <el-input v-model="model.CustomerCode"></el-input>
                        </el-form-item> -->

                        <el-form-item label="Modena" prop="CurrencyID">
                          <el-select
                            v-model="model.CurrencyID"
                            clearable
                            placeholder="Moneda"
                            v-loading="loading"
                          >
                            <el-option
                              v-for="item in list_currency"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              :disabled="!item.IsEnabled"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8" :xs="24" :sm="24" :md="24" :lg="12">
                        <el-form-item label="Fecha de cierre" prop="FinalDate">
                          <el-date-picker
                            v-model="model.FinalDate"
                            type="date"
                            placeholder="Fecha de cierre"
                            format="yyyy/MM/dd"
                          >
                          </el-date-picker>
                        </el-form-item>

                        <el-form-item
                          label="Fecha propuesta"
                          prop="DeliveryDate"
                        >
                          <el-date-picker
                            v-model="model.DeliveryDate"
                            type="date"
                            placeholder="Fecha propuesta"
                            format="yyyy/MM/dd"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <hr class="secondary-text" />

                    <div class="deal-footer">
                      <div class="flex reverse">
                        <table class="box" contenteditable="false">
                          <tbody>
                            <tr>
                              <td id="total_unit">
                                <el-form-item
                                  prop="UnitPrice"
                                  size="mini"
                                  label="Prec. unitario"
                                >
                                  <el-input-number
                                    v-model="model.UnitPrice"
                                    :min="1"
                                  ></el-input-number>
                                </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <td id="total_qty">
                                <el-form-item
                                  label="Cantidad"
                                  prop="Quantity"
                                  size="mini"
                                >
                                  <el-input-number
                                    v-model="model.Quantity"
                                    :min="1"
                                  ></el-input-number>
                                </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <td id="total_price">
                                <span style="margin-right: 78px">Total:</span>
                                {{ amount }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </el-form>
                </el-col>
              </el-row>
            </el-main>
          </el-container>
        </el-card>
        <rabbey-toolbox justify="start">
          <el-col>
            <el-button-group>
              <el-button
                type="info"
                icon="el-icon-back"
                title="Cancelar y volver atras"
                @click="rollback"
                size="mini"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-check"
                @click="save"
                size="mini"
                >Guardar</el-button
              >
              <el-button type="warning" @click="reset" size="mini"
                >Resetear</el-button
              >
            </el-button-group>
          </el-col>
        </rabbey-toolbox>
      </el-col>

      <el-col :span="10" :sm="23" :md="10" :xs="23">
        <el-card>
          <!-- <el-tabs v-model="activeName">
            <el-tab-pane name="comments">
              <span slot="label"
                ><i class="el-icon-chat-dot-round"></i> Comantarios</span
              >
              <comment-list />
            </el-tab-pane>
          </el-tabs> -->
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DealNew from "@/models/deals/DealNew";
// import CommentList from "@/components/comments/CommentList";

export default {
  name: "NewDeals",
  components: {
    // CommentList
  },
  data() {
    return {
      activeName: "comments",
      model: DealNew,
      rules: {
        Name: [{ required: true, trigger: "blur", message: "Requerido" }],
        ContactName: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        DealsTypeID: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        ContractTimeID: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        CurrencyID: [{ required: true, trigger: "blur", message: "Requerido" }],
        FinalDate: [{ required: true, trigger: "blur", message: "Requerido" }],
        DeliveryDate: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        UnitPrice: [
          { required: true, trigger: "change", message: "Requerido" },
          { type: "number", trigger: "change", message: "Debe ser numero" }
        ],
        Quantity: [
          { required: true, trigger: "change", message: "Requerido" },
          { type: "number", trigger: "change", message: "Debe ser numero" }
        ]
      },
      comments: [],
      ClientCode: this.$route.query.ClientCode,
      currentClient: null,
      Amount: 0,
      options: [],
      value: [],
      list: [],
      pages: 0,
      loading: false,
      disableCustomerName: false
    };
  },
  mounted() {
    this.$refs.form.resetFields();
    this.model = DealNew;
  },
  async created() {
    if (this.ClientCode) {
      this.disableCustomerName = true;
      await this.getCustomerByCode();
    }
  },
  beforeDestroy() {
    this.$refs.form.resetFields();
    this.model = DealNew;
  },
  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.Amount) {
            // this.$message.error("El monto es requerido");
            alert("Monto requerido");
            return false;
          }
          this.model.customerCode = this.cus;
          this.model.Amount = this.Amount;
          this.model.CreatedBy = this.currentUser.UserID;
          this.model.UpdatedBy = this.currentUser.UserID;

          this.$http
            .post("/api/deals/add", this.model)
            .then(() => {})
            .catch((error) => {
              console.error(error);
            });
        } else {
          return false;
        }
      });
    },
    rollback() {
      this.$refs.form.resetFields();
      this.Amount = 0;
      this.$router.go(-1);
    },
    reset() {
      this.$refs.form.resetFields();
    },
    handleChangeContactName(val) {
      this.currentClient =
        this.$store.getters["customers/getCustomerByName"](val)[0];
    },
    async getCustomerByCode() {
      await this.$store.dispatch("customers/getCustomerByCriteria", {
        customerCode: this.ClientCode
      });
      this.currentClient = this.$store.state.customers.result[0];
      this.model.ContactName = this.currentClient.Name;
    }
  },
  computed: {
    ...mapGetters({
      list_currency: "currency/list_to_select",
      list_times: "times/list_to_select",
      list_deal_of_types: "deal_of_type/list_to_select",
      list_customers: "customers/list_to_select",
      loading_customers: "customers/isLoading"
    }),
    amount() {
      let total = this.model.UnitPrice * this.model.Quantity;
      total = total ? total : 0;
      if (this.model.CurrencyID) {
        const cu = this.$store.getters["currency/getById"](
          this.model.CurrencyID
        );
        total = `${cu.Name} ${total}`;
      }
      return total;
    }
  },
  watch: {
    amount: function (val) {
      this.Amount = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.deal-footer {
  margin: 1rem;

  table {
    width: 35%;
    border-collapse: collapse;
    border-spacing: 0;

    tr:nth-child(2) td {
      padding-top: 0;
    }
    tr:last-child {
      border-top: 1px solid $text-color-info;
    }

    tr {
      input {
        -webkit-appearance: none;
        background-color: #ffffff;
        background-image: none;
        border-radius: 4px;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        outline: none;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;

        &:hover {
          border-color: #c0c4cc;
        }
      }
    }

    #total_price {
      font-size: 1rem;
      color: $text-color-accent;
    }
  }
}
</style>
